import axios from "../reducers/authinterceptor";
import AuthHeader from "./auth.header";

const addDecorator = async (newDecorator) => {
    const response = await axios.put(process.env.REACT_APP_API_URL + "/admin/decorator", 
    { decorator: newDecorator }, 
    { headers: AuthHeader.authHeader()});
    return response.data;
};

const getDecorator = async (id) => {
    const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/decorator/" + id,
    { headers: AuthHeader.authHeader()});
    return response.data;
};

const getDecorators = async () => {
    const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/decorators",
    { headers: AuthHeader.authHeader()});
    return response.data;
};

const updateDecorator = async (newDecorator) => {
    const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/decorator", 
    { decorator: newDecorator }, 
    { headers: AuthHeader.authHeader()});
    return response.data;
};

const deleteDecorator = async (id) => {
    const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/decorator/delete/" + id, { headers: AuthHeader.authHeader()});
    return response.data;
};

const updateDecoratorOrder = async (decoratorList) => {
    const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/decorators/order", 
    { decorators: decoratorList }, 
    { headers: AuthHeader.authHeader()});
    return response.data;
}


const DecoratorService = {
    addDecorator,
    getDecorators,
    getDecorator,
    updateDecorator,
    deleteDecorator,
    updateDecoratorOrder
};

export default DecoratorService;